import { ComponentStateType } from '.';
import { useComponentState, useStateManager } from './ComponentContext';

function App() {
  const stateManager = useStateManager<ComponentStateType>();
  const state = useComponentState<ComponentStateType>();

  return (
    <div className='App'>
      <span>{state.field1}</span>
      <button
        onClick={() => {
          stateManager.updateState({ field1: 'new' }, { type: 'clicked' });
        }}
      >
        Click
      </button>
    </div>
  );
}

export default App;
